import type { ComprobanteResumen } from '../../types/comprobante';
import { ComprobanteSoloLectura } from './ComprobanteSoloLectura';

interface ComprobanteDeTransferenciaProps {
  /** Nulo: se registró antes de que el comprobante fuera obligatorio. */
  readonly comprobante: ComprobanteResumen | null;
}

/** El comprobante de una transferencia entre juntas, para que quien recibe lo revise: imagen en el visor, PDF en pestaña nueva. */
export const ComprobanteDeTransferencia: React.FC<ComprobanteDeTransferenciaProps> = ({ comprobante }) => (
  <ComprobanteSoloLectura
    etiqueta="Comprobante de la transferencia"
    comprobante={comprobante}
    textoSinComprobante="Transferencia sin comprobante en marcha blanca"
  />
);
